import { Duration } from '@App/app/entities/shared/duration.model';

export const getDurationAsNumber = (duration: Duration): number => {
  const { startedAt, finishedAt } = duration;
  const startedDateTime = new Date(startedAt.slice(0, startedAt.lastIndexOf('.')));
  const finishedDateTime = new Date(finishedAt.slice(0, finishedAt.lastIndexOf('.')));
  return (finishedDateTime.getTime() - startedDateTime.getTime()) / 1000;
};
